import { isClockTime } from "@/lib/clock";
import { isQuarterPoint, QUARTER_MESSAGE, weekGoalError } from "@/lib/points";
import type { SleepLogConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";
import { maxScoreWeek } from "./scoring";

export function validate(config: SleepLogConfig): WidgetValidationResult {
  const errors: Record<string, string> = {};

  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  if (!isClockTime(config.asleepTarget)) {
    errors.asleepTarget = "Mål for å sovne kreves.";
  }
  if (!isClockTime(config.awakeTarget)) {
    errors.awakeTarget = "Mål for å våkne kreves.";
  }

  if (!Number.isFinite(config.points)) {
    errors.points = "Poeng kreves.";
  } else if (config.points <= 0) {
    errors.points = "Poeng må være over 0.";
  } else if (!isQuarterPoint(config.points)) {
    errors.points = QUARTER_MESSAGE;
  }

  if (!Number.isFinite(config.intervalMinutes)) {
    errors.intervalMinutes = "Intervall kreves.";
  } else if (
    !Number.isInteger(config.intervalMinutes) ||
    config.intervalMinutes < 1
  ) {
    errors.intervalMinutes = "Intervall må være et helt antall minutter.";
  }

  if (!Number.isFinite(config.reductionPerInterval)) {
    errors.reductionPerInterval = "Trekk kreves.";
  } else if (config.reductionPerInterval <= 0) {
    // A trekk of 0 never decays, which would award full points at any hour
    // and make the two target fields meaningless.
    errors.reductionPerInterval = "Trekk må være over 0.";
  } else if (!isQuarterPoint(config.reductionPerInterval)) {
    errors.reductionPerInterval = QUARTER_MESSAGE;
  }

  const goalError = weekGoalError(config.weekGoal, {
    max: maxScoreWeek(config),
  });
  if (goalError) errors.weekGoal = goalError;

  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
